import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { excludedPatterns } from '@/utils/visibility'

const useOneTrustVisibility = () => {
  const router = useRouter()

  useEffect(() => {
    const shouldHideOneTrust = excludedPatterns.some(pattern =>
      router.pathname.includes(pattern)
    )

    if (!shouldHideOneTrust) return

    // Função para ocultar os elementos do OneTrust
    const hideOneTrustElements = () => {
      const oneTrustBanner = document.querySelector('#onetrust-banner-sdk')
      const oneTrustPolicy = document.querySelector('#onetrust-policy')
      const oneTrustConsent = document.querySelector('#onetrust-consent-sdk')

      if (oneTrustBanner) oneTrustBanner.style.display = 'none'
      if (oneTrustPolicy) oneTrustPolicy.style.display = 'none'
      if (oneTrustConsent) oneTrustConsent.style.display = 'none'
    }

    // Configurar o MutationObserver para observar mudanças no DOM
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          const oneTrustElement = document.querySelector(
            '#onetrust-consent-sdk'
          )
          if (oneTrustElement) {
            hideOneTrustElements()
            observer.disconnect()
          }
        }
      })
    })

    // Começar a observar o body para detectar quando o OneTrust é inserido
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    // Verificar se o elemento já existe (caso o GTM já tenha carregado)
    if (document.querySelector('#onetrust-consent-sdk')) {
      hideOneTrustElements()
      observer.disconnect()
    }

    // Limpar o observer quando o componente for desmontado
    return () => {
      observer.disconnect()
    }
  }, [router.pathname])
}

export default useOneTrustVisibility
